import axios from "axios"
import baseUrl from "./apiUrl";

const buildHeaders =()=>({
  'Accept': 'application/json',
  'Content-Type': 'application/json',
  'Authorization': 'Bearer ' + localStorage.getItem("token")
});

export async function removeDocuments_request(id) {
  try {
      let resp;
      const response = await axios({
          url: baseUrl + `/documents/${id}`,
          method: "DELETE",
          headers: buildHeaders()

      })

      if (response.status === 200) {
          resp = {
              "ok": true,
              "status": 200,
              "data": response.data.Respuesta
          };
      } else {
          resp = {
              "ok": false,
              "status": 500
          };
      }
      return resp;
  } catch (error) {
      return {
          "ok": false,
          "status": 500,
          "mensaje": error.response !== undefined ? error.response.data.exception === undefined ? error.response.data.Error.Motivo : "Error desconocido" : error.message,
      };

  }
}

export async function getMedicalDocuments(patientId) {
    try {
        const response = await axios({
            url: baseUrl + `/contact/${patientId}/medicalDocuments`,
            method: "GET",
            headers: buildHeaders()
        });

        return response.data.Respuesta;
    } catch (error) {
        throw new Error(error.message);
    }
}

export async function uploadMedicalDocuments(patientId, documents) {
    try {
        const response = await axios({
            url: baseUrl + `/contact/${patientId}/documents`,
            method: "POST",
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem("token")
            },
            data: documents
        });

        return response;
    } catch(error) {
        throw new Error(error.message);
    }
}
